export const MEDIA_TABLET_POINTS = 1000;
export const MEDIA_MOBILE_POINTS = 767;
